<i18n src="@/locales/modules/UserSettingsTranslate.json"></i18n>

<template>
	<vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
		<!-- GENERAL -->
		<vs-tab icon-pack="nucleo" icon="text-lg nucleo-single-01-2" :label="$t('General')">
			<div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
				<user-settings-general />
			</div>
		</vs-tab>
		<vs-tab v-if="this.$store.state.AppActiveUser.role.is_student" icon-pack="nucleo" icon="text-lg nucleo-file-paragraph" :label="$t('ProfileDormitory.StudentData')">
			<div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
				<UserSettingsStudentData />
			</div>
		</vs-tab>
		<vs-tab v-if="this.$store.state.AppActiveUser.role.is_student" icon-pack="nucleo" icon="text-lg nucleo-file-paragraph" :label="$t('ProfileDormitory.Point')">
			<div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
				<UserSettingsStudentPoint />
			</div>
		</vs-tab>
		<vs-tab icon-pack="nucleo" icon="text-lg nucleo-cmpassword-glyph" :label="$t('ChangePassword')">
			<div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
				<user-settings-change-password />
			</div>
		</vs-tab>
		<vs-tab icon-pack="nucleo" icon="text-lg nucleo-settings-gear-2" :label="$t('Settings')">
			<div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
				<user-settings-config />
			</div>
		</vs-tab>
		<vs-tab icon-pack="nucleo" icon="text-lg nucleo-bell-2" :label="$t('Notifications')">
			<div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
				<UserSettingsNotifications />
			</div>
		</vs-tab>
	</vs-tabs>
</template>

<script>
import UserSettingsInfo from "./UserSettingsInfo.vue";
import UserSettingsConfig from "./UserSettingsConfig.vue";
import UserSettingsGeneral from "./UserSettingsGeneral.vue";
import UserSettingsSocialLinks from "./UserSettingsSocialLinks.vue";
import UserSettingsConnections from "./UserSettingsConnections.vue";
import UserSettingsNotifications from "./UserSettingsNotifications.vue";
import UserSettingsChangePassword from "./UserSettingsChangePassword.vue";
import UserSettingsStudentData from "./student/UserSettingsStudentData";
import UserSettingsStudentPoint from "./student/UserSettingsStudentPoint";

export default {
	components: {
		UserSettingsStudentPoint,
		UserSettingsStudentData,
		UserSettingsGeneral,
		UserSettingsChangePassword,
		UserSettingsInfo,
		UserSettingsSocialLinks,
		UserSettingsConnections,
		UserSettingsNotifications,
		UserSettingsConfig
	},
	data() {
		return {};
	},
	computed: {
		isSmallerScreen() {
			return this.$store.state.windowWidth < 768;
		}
	}
};
</script>

<style lang="scss">
#profile-tabs {
	.vs-tabs--content {
		padding: 0;
	}

	.vs-tabs--btn {
		width: 200px;
	}

	&.vs-tabs-position-top {
		li {
			flex: 1 1 0;
			display: flex;
			justify-content: center;

			.vs-tabs--btn {
				width: auto;

				@media screen and (max-width: 576px) {
					flex-direction: column;
					justify-content: center;

					span {
						display: none;
					}
				}
			}
		}
	}
}
.con-slot-tabs {
	width: 100%;
}
</style>
